import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import OldBookQuickDrawer from '@/components/old-book-quick-drawer/OldBookQuickDrawer.vue';
import axios from '@/config/axios';
import {useHead} from "@vueuse/head";

export default {
  name: 'OldBookList',
  components: {
    Header,
    Footer,
    OldBookQuickDrawer
  },
  data() {
    return {
      booths: [],
      searchKeyword: '',
      searchDebounceTimer: null,
      priceDebounceTimer: null,
      priceFromK: '',
      priceToK: '',
      quickPrice: '',
      selectedSaleType: null, // null: all, 0: ALLOW_SINGLE, 1: COMBO_ONLY
      selectedStatus: null, // null means all
      selectedSort: 'default', // 'default', 'price_asc', 'price_desc'
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,
      isLoading: false,

      bookIdFilter: null,
      filteredBookName: '',

      quickPriceOptions: [
        { id: '', label: 'Chọn nhanh mức giá' },
        { id: 'under100', label: 'Dưới 100.000đ' },
        { id: '100to200', label: '100.000đ - 200.000đ' },
        { id: '200to500', label: '200.000đ - 500.000đ' },
        { id: 'above500', label: 'Trên 500.000đ' }
      ],
      // Quick View Drawer & Zoom State
      drawerBooth: null,
      drawerActiveImg: null,
      showZoomModal: false,
      zoomScale: 1,
      zoomPanX: 0,
      zoomPanY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      toolbarHidden: false,
      head: null
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token');
    },
    hasActiveFilters() {
      return !!(this.searchKeyword || this.selectedSaleType !== null || this.selectedStatus !== null || this.priceFromK !== '' || this.priceToK !== '' || this.selectedSort !== 'default' || this.bookIdFilter);
    },
    visiblePages() {
      const current = this.currentPage;
      const total = this.totalPages;
      if (total <= 7) return Array.from({ length: total }, (_, i) => i);

      const pages = [0];
      const start = Math.max(1, current - 1);
      const end = Math.min(total - 2, current + 1);

      if (start > 1) pages.push('...');
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < total - 2) pages.push('...');
      pages.push(total - 1);
      
      return pages;
    }
  },
  watch: {
    '$route.query': {
      handler(query) {
        if (query && query.tab === 'my-books') {
          this.$router.replace('/my-old-books');
          return;
        }
        if (query && query.idBook) {
          this.bookIdFilter = query.idBook;
          this.filteredBookName = query.bookName || query.keyword || '';
        } else if (!query || !query.idBook) {
          this.bookIdFilter = null;
          this.filteredBookName = '';
        }
        if (query && query.keyword !== undefined) {
          this.searchKeyword = query.keyword;
        }
        this.fetchBooths(0);
      }
    },
    showZoomModal(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.handleZoomKeydown);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.handleZoomKeydown);
      }
    }
  },
  mounted() {
    if (this.$route.query.idBook) {
      this.bookIdFilter = this.$route.query.idBook;
      this.filteredBookName = this.$route.query.bookName || this.$route.query.keyword || '';
    }
    if (this.$route.query.keyword && !this.searchKeyword) {
      this.searchKeyword = this.$route.query.keyword;
    }
    this.fetchBooths(0);
    this.head = useHead({
      title: "Nền tảng trao đổi sách cũ trong cộng đồng yêu văn học",
      meta: [
        {
          name: 'description',
          content: "Trao đổi và thanh lý sách cũ chất lượng từ cộng đồng yêu văn học. Tiết kiệm chi phí, giao nhận nhanh chóng, bảo vệ giao dịch tối đa..."
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: `${window.location.origin}${this.$route.path}`
        }
      ]
    })
  },
  beforeUnmount() {
    if (this.head && typeof this.head.dispose === 'function') {
      this.head.dispose();
      this.head = null;
    }
  },
  methods: {
    clearBookFilter() {
      this.bookIdFilter = null;
      this.filteredBookName = '';
      if (this.$route.query.idBook) {
        const query = { ...this.$route.query };
        delete query.idBook;
        delete query.bookName;
        this.$router.replace({ query });
      }
      this.fetchBooths(0);
    },
    onPriceFromInput(event) {
      this.priceFromK = this.stripPriceInput(event.target.value);
      this.onPriceInput();
    },
    onPriceToInput(event) {
      this.priceToK = this.stripPriceInput(event.target.value);
      this.onPriceInput();
    },
    stripPriceInput(value) {
      if (value === null || value === undefined) return '';
      const digits = String(value).replace(/[^\d]/g, '');
      if (!digits) return '';
      const num = parseFloat(digits);
      if (isNaN(num) || num < 0) return '';
      const MAX_PRICE = 500000000;
      if (num > MAX_PRICE) {
        this.$toast.warning('Giá nhập tối đa là 500.000.000đ.');
        return String(MAX_PRICE);
      }
      return digits;
    },
    formatPriceInput(value) {
      if (value === '' || value === null || value === undefined) return '';
      const digits = String(value).replace(/[^\d]/g, '');
      if (!digits) return '';
      return Number(digits).toLocaleString('vi-VN');
    },
    onPriceInput() {
      if (this.quickPrice !== '') {
        this.quickPrice = '';
      }
      if (this.priceDebounceTimer) {
        clearTimeout(this.priceDebounceTimer);
      }
      this.priceDebounceTimer = setTimeout(() => {
        this.handleSearch();
      }, 300);
    },
    onQuickPriceChange() {
      const preset = this.quickPriceOptions.find(q => q.id === this.quickPrice);
      if (!preset) return;
      this.priceFromK = '';
      this.priceToK = '';
      if (this.quickPrice === 'under100') {
        this.priceToK = '100000';
      } else if (this.quickPrice === '100to200') {
        this.priceFromK = '100000';
        this.priceToK = '200000';
      } else if (this.quickPrice === '200to500') {
        this.priceFromK = '200000';
        this.priceToK = '500000';
      } else if (this.quickPrice === 'above500') {
        this.priceFromK = '500000';
      }
      this.handleSearch();
    },
    parsePriceInput(value) {
      if (value === '' || value === null || value === undefined) return null;
      const num = parseFloat(value);
      if (isNaN(num) || num < 0) return null;
      return Math.min(num, 500000000);
    },
    clearPriceFilter() {
      this.priceFromK = '';
      this.priceToK = '';
      this.quickPrice = '';
      this.handleSearch();
    },
    formatPriceFilter() {
      const from = this.parsePriceInput(this.priceFromK);
      const to = this.parsePriceInput(this.priceToK);
      if (from !== null && to !== null) {
        return this.formatPrice(from) + ' - ' + this.formatPrice(to);
      }
      if (from !== null) {
        return 'Từ ' + this.formatPrice(from);
      }
      if (to !== null) {
        return 'Đến ' + this.formatPrice(to);
      }
      return '';
    },
    onSearchInput() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.handleSearch();
      }, 300);
    },
    handleSearch() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.currentPage = 0;
      this.fetchBooths(0);
    },
    clearSearch() {
      this.searchKeyword = '';
      this.handleSearch();
    },
    resetFilters() {
      this.searchKeyword = '';
      this.selectedSaleType = null;
      this.selectedStatus = null;
      this.priceFromK = '';
      this.priceToK = '';
      this.quickPrice = '';
      this.selectedSort = 'default';
      this.bookIdFilter = null;
      this.filteredBookName = '';
      this.fetchBooths(0);
    },
    fetchBooths(page) {
      if (page < 0 || (this.totalPages > 0 && page >= this.totalPages)) return;
      
      this.isLoading = true;

      const priceFrom = this.parsePriceInput(this.priceFromK);
      const priceTo = this.parsePriceInput(this.priceToK);
      let params = { page };
      if (this.searchKeyword) params.keyword = this.searchKeyword;
      if (this.selectedSaleType !== null && this.selectedSaleType !== undefined) params.saleType = this.selectedSaleType;
      if (this.selectedStatus !== null && this.selectedStatus !== undefined) params.status = this.selectedStatus;
      if (priceFrom !== null && priceFrom !== undefined) params.priceFrom = priceFrom;
      if (priceTo !== null && priceTo !== undefined) params.priceTo = priceTo;
      if (this.selectedSort && this.selectedSort !== 'default') params.sort = this.selectedSort;
      if (this.bookIdFilter) params.idBook = this.bookIdFilter;

      axios.get("/old-book/v1/search", { params })
        .then(res => {
          if (res.data.status === '200') {
            const result = res.data.result;
            const items = result.content || [];

            const isValidImg = (val) => {
              if (!val || typeof val !== 'string') return false;
              const trimmed = val.trim();
              return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'NaN';
            };

            this.booths = items.map(item => {
              ['stackImage', 'coverImage'].forEach(k => {
                if (!isValidImg(item[k])) {
                  item[k] = null;
                } else if (!item[k].startsWith('data:') && !item[k].startsWith('http')) {
                  item[k] = 'data:image/png;base64,' + item[k];
                }
              });
              if (item.books && Array.isArray(item.books)) {
                item.books.forEach(b => {
                  ['cover', 'coverBack'].forEach(k => {
                    if (!isValidImg(b[k])) {
                      b[k] = null;
                    } else if (!b[k].startsWith('data:') && !b[k].startsWith('http')) {
                      b[k] = 'data:image/png;base64,' + b[k];
                    }
                  });
                });
              }
              return item;
            });
            this.currentPage = page;
            this.totalPages = result.totalPages || 0;
            this.totalElements = result.totalElements || 0;
          } else {
            this.booths = [];
          }
        })
        .catch(err => {
          console.error(err);
          this.booths = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openQuickDrawer(booth) {
      this.drawerBooth = booth;
      this.drawerActiveImg = booth.coverImage || (booth.books && booth.books[0] && booth.books[0].cover);
    },
    closeQuickDrawer() {
      this.drawerBooth = null;
      this.drawerActiveImg = null;
    },
    goToCreateBook() {
      if (!this.isLoggedIn) {
        this.$toast.error('Vui lòng đăng nhập để đăng bán gian hàng sách!');
        this.$router.push('/login');
      } else {
        this.$router.push('/old-books/create');
      }
    },
    goToDetail(id) {
      this.$router.push('/old-books/' + id);
    },
    getCoverUrl(path) {
      const defaultPlaceholder = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3EGian H%C3%A0ng%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return defaultPlaceholder;
      if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) {
        return path;
      }
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) {
        return 'data:image/jpeg;base64,' + path;
      }

      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      } else if (cleanPath.includes('cover/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      } else if (cleanPath.includes('storge/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      }
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');

      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');

      if (apiHost) {
        return `${apiHost}/${cleanPath}`;
      }
      return `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return 'Liên hệ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    formatWeight(grams) {
      if (!grams || grams <= 0) return '0g';
      if (grams >= 1000) {
        return (grams / 1000).toFixed(1).replace('.0', '') + ' kg';
      }
      return grams + 'g';
    },
    getConditionLabel(verStatus) {
      const conditions = {
        0: 'Rất mới',
        1: 'Như mới',
        2: 'Khá mới',
        3: 'Trung bình',
        4: 'Cũ'
      };
      return conditions[verStatus] || 'Khác';
    },
    getListingStatusLabel(status) {
      const statuses = {
        0: 'Đang bán',
        1: 'Đã nhận cọc',
        2: 'Đã bán',
        3: 'Tạm ngưng',
        4: 'Đã hủy'
      };
      return statuses[status] !== undefined ? statuses[status] : 'Đang bán';
    },
    openQuickDrawer(booth) {
      if (!booth) return;
      this.drawerBooth = booth;
      this.drawerActiveImg = booth.coverImage || booth.stackImage || (booth.books && booth.books[0] && booth.books[0].cover) || null;
    },
    closeQuickDrawer() {
      this.drawerBooth = null;
      this.drawerActiveImg = null;
    },
    getDrawerMediaList(booth) {
      if (!booth) return [];
      const list = [];
      if (booth.stackImage) {
        list.push({ url: booth.stackImage, label: 'Chồng sách' });
      }
      if (booth.books && Array.isArray(booth.books)) {
        booth.books.forEach((b, idx) => {
          if (b.cover) list.push({ url: b.cover, label: `C.${idx + 1} Bìa trước` });
          if (b.coverBack) list.push({ url: b.coverBack, label: `C.${idx + 1} Bìa sau` });
        });
      }
      return list;
    },
    getAuthorsList(booth) {
      if (!booth || !booth.books || !Array.isArray(booth.books)) return [];
      const names = [];
      booth.books.forEach(b => {
        if (b.author && b.author.trim() && !names.includes(b.author.trim())) {
          names.push(b.author.trim());
        }
      });
      return names;
    },
    goToDetail(id) {
      if (id) this.$router.push('/old-books/' + id);
    },
    addDrawerBoothToCart(booth) {
      if (!booth) return;
      const item = {
        id: `booth_${booth.id}`,
        boothId: booth.id,
        boothName: booth.name,
        sellerId: booth.createBy,
        sellerName: booth.createByName,
        saleType: booth.saleType,
        type: booth.saleType === 1 ? 'COMBO' : 'BOOTH',
        name: booth.name,
        cover: booth.stackImage || booth.coverImage || (booth.books && booth.books[0] && booth.books[0].cover),
        price: booth.price,
        weight: booth.weight || 350,
        totalBooks: booth.totalBooks,
        perStatus: booth.books && booth.books.length === 1 ? booth.books[0].perStatus : null,
        verStatus: booth.books && booth.books.length === 1 ? booth.books[0].verStatus : null
      };
      this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
      this.closeQuickDrawer();
      this.$toast.success(`Đã thêm "${booth.name}" vào giỏ hàng!`);
    },
    addDrawerBookToCart(book, booth) {
      if (!book || !booth) return;
      const bookKey = book.id || book.idBook || book.name;
      const item = {
        id: `book_${booth.id}_${bookKey}`,
        boothId: booth.id,
        boothName: booth.name,
        bookId: book.id || book.idBook,
        sellerId: booth.createBy,
        sellerName: booth.createByName,
        saleType: booth.saleType,
        type: 'SINGLE',
        name: book.name,
        author: book.author,
        cover: book.cover || book.coverBack,
        price: book.price,
        weight: book.weight || (booth.weight && booth.books ? Math.round(booth.weight / booth.books.length) : 250),
        perStatus: book.perStatus,
        verStatus: book.verStatus
      };
      this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
      this.$toast.success(`Đã thêm "${book.name}" vào giỏ hàng!`);
    },
    clampNum(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    openZoomModal(img) {
      if (img && typeof img === 'string') {
        this.drawerActiveImg = img;
      }
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      this.toolbarHidden = false;
      this.showZoomModal = true;
    },
    closeZoomModal() {
      this.showZoomModal = false;
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      clearTimeout(this._panHideTimer);
      this.toolbarHidden = false;
    },
    applyZoom(newScale, anchorX = 0, anchorY = 0) {
      const target = this.clampNum(newScale, 0.5, 4);
      const ratio = target / this.zoomScale;
      const maxPan = this.maxPanForScale(target);
      this.zoomPanX = this.clampNum(anchorX - (anchorX - this.zoomPanX) * ratio, -maxPan, maxPan);
      this.zoomPanY = this.clampNum(anchorY - (anchorY - this.zoomPanY) * ratio, -maxPan, maxPan);
      this.zoomScale = target;
    },
    zoomIn() {
      this.applyZoom(this.zoomScale + 0.35);
    },
    zoomOut() {
      this.applyZoom(this.zoomScale - 0.35);
    },
    resetZoom() {
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      this.toolbarHidden = false;
    },
    toggleDblZoom() {
      if (this.zoomScale > 1) {
        this.resetZoom();
      } else {
        this.applyZoom(2);
      }
    },
    handleWheelZoom(e) {
      if (!this.showZoomModal) return;
      const stage = this.$refs.zoomStage;
      let anchorX = 0;
      let anchorY = 0;
      if (stage) {
        const rect = stage.getBoundingClientRect();
        anchorX = e.clientX - rect.left - rect.width / 2;
        anchorY = e.clientY - rect.top - rect.height / 2;
      }
      this.applyZoom(this.zoomScale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), anchorX, anchorY);
    },
    handleZoomKeydown(e) {
      if (!this.showZoomModal) return;
      const panStep = 40;
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.closeZoomModal();
        return;
      }
      if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        this.zoomIn();
        return;
      }
      if (e.key === '-' || e.key === '_') {
        e.preventDefault();
        this.zoomOut();
        return;
      }
      if (e.key === '0') {
        this.resetZoom();
        return;
      }
      if (this.zoomScale <= 1) return;
      const maxPan = this.maxPanForScale(this.zoomScale);
      this.toolbarHidden = true;
      clearTimeout(this._panHideTimer);
      this._panHideTimer = setTimeout(() => { this.toolbarHidden = false; }, 700);
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.zoomPanY = this.clampNum(this.zoomPanY - panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.zoomPanY = this.clampNum(this.zoomPanY + panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.zoomPanX = this.clampNum(this.zoomPanX - panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.zoomPanX = this.clampNum(this.zoomPanX + panStep, -maxPan, maxPan);
      }
    },
    startDrag(e) {
      if (this.zoomScale <= 1) return;
      if (e.button !== 0) return;
      e.preventDefault();
      this.isDragging = true;
      this.toolbarHidden = true;
      this.dragStartX = e.clientX - this.zoomPanX;
      this.dragStartY = e.clientY - this.zoomPanY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const maxPan = this.maxPanForScale(this.zoomScale);
      this._dragNextX = this.clampNum(e.clientX - this.dragStartX, -maxPan, maxPan);
      this._dragNextY = this.clampNum(e.clientY - this.dragStartY, -maxPan, maxPan);
      if (this._dragRaf) return;
      this._dragRaf = requestAnimationFrame(() => {
        this._dragRaf = null;
        this.zoomPanX = this._dragNextX;
        this.zoomPanY = this._dragNextY;
      });
    },
    stopDrag() {
      this.isDragging = false;
      if (this._dragRaf) {
        cancelAnimationFrame(this._dragRaf);
        this._dragRaf = null;
        this.zoomPanX = this._dragNextX;
        this.zoomPanY = this._dragNextY;
      }
      this.toolbarHidden = false;
    }
  },
  unmounted() {
    if (this.head && typeof this.head.dispose === 'function') {
      this.head.dispose();
    }
  }
};
